import { render, staticRenderFns } from "./MoonConstellationWidget.vue?vue&type=template&id=8655c6f0&scoped=true&"
import script from "./MoonConstellationWidget.vue?vue&type=script&lang=js&"
export * from "./MoonConstellationWidget.vue?vue&type=script&lang=js&"
import style0 from "./MoonConstellationWidget.vue?vue&type=style&index=0&id=8655c6f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8655c6f0",
  null
  
)

export default component.exports